import { render, staticRenderFns } from "./provincialWarningManage.vue?vue&type=template&id=452e2ed4&scoped=true"
import script from "./provincialWarningManage.js?vue&type=script&lang=js&external"
export * from "./provincialWarningManage.js?vue&type=script&lang=js&external"
import style0 from "./provincialWarningManage.scss?vue&type=style&index=0&id=452e2ed4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452e2ed4",
  null
  
)

export default component.exports